import { z } from "zod";
import { BooleanSchema, StringSchema, UuidSchema } from "./common-schema";

export const TaskReq = z.object({
  id: StringSchema,
  name: StringSchema,
  isCompleted: BooleanSchema,
  owners: z.array(UuidSchema).max(10, "Max of 10 members"),
});
